/**
 * 登录组件
 */

import { useState, useRef, useEffect } from 'react';
import {
    ConfigProvider,
    Input,
    Row,
    Col,
    Button,
    message,
    Flex,
} from 'antd';
import $ from 'jquery';
import cookie from 'react-cookies';
import {
    UserOutlined,
    LockOutlined,
    PhoneOutlined,
    CodeOutlined,
    LoadingOutlined,
} from '@ant-design/icons';

import {
    winWidth,
    winHeight,
    UjoinParams,
    isMobileDevice,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const { Search } = Input;

/***
 * 控制获取验证码按钮文字显示
 */
const BtbCodeTitle = (props) => {
    const [title, setTitle] = useState('获取验证码');
    useEffect(() => {
        if (props.vTime > 0) {
            setTimeout(function () {
                props.setVTime(props.vTime - 1);
            }, 1000);
            setTitle(props.vTime - 1 + 's 后获取验证码');
        }
        if (props.vTime < 1) {
            setTitle('获取验证码');
        }
    }, [props]);

    return title;
}

const Login = () => {
    const [loading, setLoading] = useState(false);
    const [loginMode, setLoginMode] = useState('account_password');
    const [account, setAccount] = useState('');
    const [password, setPassword] = useState('');
    const [phone, setPhone] = useState('');
    const [verifyCode, setVerifyCode] = useState('');   // 验证码
    const [vTime, setVTime] = useState(0);              // 验证码倒计时
    const [verifyId, setVerifyId] = useState('');       // 校验id

    const passwordRef = useRef(null);
    const verifyCodeRef = useRef(null);
    const loginRef = useRef(null);

    useEffect(() => {
        /**
         * 判断用户是个已登录
         * 通过cookie中是否存储有keyId、keyUid和keyToken
         * 存在，则直接跳转到根路径。
         */
        if (cookie.load(CNF.cookies.keyId)
            && cookie.load(CNF.cookies.keyToken)
            && cookie.load(CNF.cookies.keyUid)) {
            window.location.href = isMobileDevice ? CNF.chatUrl : CNF.homeUrl;
        }
    }, []);

    const login = () => {
        let params = {
            'login_mode': loginMode,
        }
        if (loginMode === 'account_password') {
            // 账户密码登录
            if (account === '') {
                message.error('账户不能为空！', CNF.messageDuration);
                return;
            }
            if (password === '') {
                message.error('密码不能为空！', CNF.messageDuration);
                return;
            }
            params['account'] = account;
            params['password'] = password;
        } else if (loginMode === 'phone_verify') {
            // 验证码校验
            let rex = CNF.regex.verifyCode.exec(verifyCode);
            if (rex === null || rex[0] !== verifyCode) {
                message.error('验证码格式错误！', CNF.messageDuration);
                return;
            }
            if (!verifyId) {
                message.error('验证码失效，请重新获取！', CNF.messageDuration);
                return;
            }
            params['phone'] = phone;
            params['verify_code'] = verifyCode;
            params['verify_id'] = verifyId;
        } else {
            return;
        }
        getAuthorizationCode(params);
    }

    /**
     * 验证账户
     * @returns 
     */
    const verifyAccount = (phone) => {
        setPhone(phone);
        // 手机格式校验
        let rex = CNF.regex.phone.exec(phone);
        if (rex === null || rex[0] !== phone) {
            message.error('手机号格式错误！', CNF.messageDuration);
            return;
        }
        // 发送请求验证账户
        $.ajax({
            url: CNF.api + 'users/verify/account',
            type: 'GET',
            dataType: 'JSON',
            data: {
                'type': 'phone',
                'account': phone
            }, success: function (data) {
                if (data.res === 0) {
                    // 验证账户已存在
                    if (data.dat.account) {
                        // 获取验证Id
                        setVerifyId(data.dat.verify_id);
                        // 发送验证码
                        sendVerifyCode(data.dat.verify_id, phone);
                    } else {
                        message.error('手机号不存在！', CNF.messageDuration);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /**
     * 发送验证码
     * @param {*} verifyId 
     * @param {*} account
     */
    const sendVerifyCode = (verifyId, account) => {
        setVTime(60);
        $.ajax({
            url: CNF.api + 'users/send/verifyCode',
            type: 'GET',
            dataType: 'JSON',
            data: {
                'method': 'phone',
                'template_code': 'login',
                'verify_id': verifyId,
                'account': account,
            }, success: function (data) {
                if (data.res === 0) {
                    message.success('发送成功', CNF.messageDuration);
                    verifyCodeRef.current.focus({ cursor: 'start', });
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /**
     * 获取登录授权码
     * @param {*} params 
     */
    const getAuthorizationCode = (params) => {
        setLoading(true);
        $.ajax({
            url: `${CNF.authApi}`,
            data: JSON.stringify(params),
            type: 'POST', success: function (data) {
                if (data.res === 0) {
                    // 获取令牌
                    getToken(data.dat);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                    setLoading(false);
                }
            }
        });
    }

    /**
     * 向授权中心获取令牌
     * @param {*} acodeObj 
     */
    const getToken = (acodeObj) => {
        const params = {
            'grant_type': 'authorization_code',
            'client_id': acodeObj.client_id,
            'client_secret': acodeObj.client_secret,
            'scope': 'all',
            'code': acodeObj.code
        }
        $.ajax({
            url: `${CNF.tlerApi}${UjoinParams(params)}`,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    message.success(data.msg, CNF.messageDuration);
                    // 存储Cookies
                    saveCookies(data);
                    setTimeout(function () {
                        // 重定向到主页或chat
                        window.location.href = data.info?.jump_url || (isMobileDevice ? CNF.chatUrl : CNF.homeUrl);
                    }, CNF.messageDuration * 1000);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                    setLoading(false);
                }
            }
        });
    }

    /**
     * 令牌相关信息存入Cookie
     * @param {*} tokenArr 
     */
    const saveCookies = (tokenArr) => {
        cookie.save(CNF.cookies.keyId, tokenArr.info.username,
            { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire });
        cookie.save(CNF.cookies.keyUid, tokenArr.info.uid,
            { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire });
        cookie.save(CNF.cookies.keyDisplayname, tokenArr.info.displayname,
            { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire });
        cookie.save(CNF.cookies.keyToken, tokenArr.access_token,
            { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: tokenArr.expires_in });
        if (tokenArr.info.avatar_url) {
            cookie.save(CNF.cookies.keyAvatarUrl, tokenArr.info.avatar_url,
                { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire });
        }
        if (tokenArr.info.theme_color) {
            cookie.save(CNF.cookies.keyThemeColor, tokenArr.info.theme_color,
                { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire });
        } else {
            cookie.save(CNF.cookies.keyThemeColor, CNF.themeColors[0],
                { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire });
        }
        cookie.save(CNF.cookies.keyIsDisplayTableBorder, tokenArr.info.is_display_table_border,
            { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire });

    }

    return (
        <Flex style={{
            width: winWidth,
            height: winHeight,
            background: '#001529',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <ConfigProvider componentSize='large'
                input={{
                    style: {
                        backgroundColor: '#fff',
                    }
                }}
            >
                <div style={{
                    border: 'solid 2px',
                    borderColor: '#FF904D',
                    borderRadius: '0px', padding: '40px 30px',
                    margin: '0 15px',
                    width: isMobileDevice ? '100%' : winWidth / (winWidth > 1792 ? 5 : 4)
                }}>
                    <Row justify='center' style={{ marginBottom: '25px', }}>
                        <Col span={11}>
                            <Button
                                style={{ width: '100%', borderRadius: '0px' }}
                                type={loginMode === 'account_password' ? 'primary' : 'default'}
                                icon={isMobileDevice ? null : <UserOutlined />}
                                onClick={() => setLoginMode('account_password')}
                            >
                                账号密码登录
                            </Button>
                        </Col>
                        <Col span={11} offset={2} onClick={() => setLoginMode('phone_verify')}>
                            <Button
                                style={{ width: '100%', borderRadius: '0px' }}
                                type={loginMode === 'phone_verify' ? 'primary' : 'default'}
                                icon={isMobileDevice ? null : <PhoneOutlined />}
                            >
                                手机验证登录
                            </Button>
                        </Col>
                    </Row>
                    {
                        loginMode && loginMode === 'account_password' ? (
                            <Row>
                                <Col span={24} style={{ marginBottom: '25px', }}>
                                    <Input
                                        placeholder='请输入账户'
                                        variant='Outlined'
                                        onChange={(e) => { setAccount(e.target.value); }}
                                        onPressEnter={() => passwordRef.current.focus({
                                            cursor: 'start',
                                        })} //   回车密码聚焦
                                        width='100%'
                                        style={{ borderRadius: '0', height: '40px', lineHeight: '40px' }}
                                        prefix={<UserOutlined />}
                                    />
                                </Col>
                                <Col span={24}>
                                    <Input.Password
                                        placeholder='请输入密码'
                                        variant='Outlined'
                                        ref={passwordRef}
                                        onChange={(e) => { setPassword(e.target.value); }}
                                        onPressEnter={() => {
                                            login();
                                            loginRef.current.focus({
                                                cursor: 'start',
                                            });
                                        }} //  回车登录
                                        width='100%'
                                        style={{ borderRadius: '0', height: '40px', lineHeight: '40px' }}
                                        prefix={<LockOutlined />}
                                    />
                                </Col>
                            </Row>
                        ) : (
                            <Row>
                                <Col span={24} style={{ marginBottom: '25px', lineHeight: '40px' }}>
                                    <Search
                                        placeholder='请输入手机号'
                                        prefix={<PhoneOutlined />}
                                        variant='Outlined'
                                        onSearch={(value) => {
                                            if (vTime > 0) return;
                                            verifyAccount(value);
                                        }}
                                        enterButton={<Button
                                            type='link'
                                            style={{
                                                borderLeft: '1px solid #D7D7D7',
                                                borderRadius: '0px',
                                                width: (isMobileDevice ? winWidth : winWidth / (winWidth > 1792 ? 5 : 4)) * 11 / 24
                                            }}><BtbCodeTitle vTime={vTime} setVTime={setVTime} /></Button>}
                                        style={{
                                            width: '100%',
                                            borderRadius: '0px',
                                        }}
                                        onPressEnter={() => verifyCodeRef.current.focus({
                                            cursor: 'start',
                                        })} //   回车验证码聚焦
                                    />
                                </Col>
                                <Col span={24}>
                                    <Input
                                        placeholder='请输入验证码'
                                        variant='Outlined'
                                        ref={verifyCodeRef}
                                        onChange={(e) => { setVerifyCode(e.target.value) }}
                                        onPressEnter={() => {
                                            login();
                                            loginRef.current.focus({
                                                cursor: 'start',
                                            });
                                        }} //  回车登录
                                        width='100%'
                                        style={{ borderRadius: '0', height: '40px', lineHeight: '40px' }}
                                        prefix={<CodeOutlined />}
                                    />
                                </Col>
                            </Row>
                        )
                    }
                    <Row style={{ marginBottom: '20px' }}>
                        <Col span={24}>
                            <Button
                                align='left' type='link' style={{ color: '#fff', fontSize: 12, margin: 0, }}
                                href={(CNF.basename ? CNF.basename : '') + '/users/security/findPassword/m=password&t=' + Date.parse(new Date()) / CNF.tDivisor + '&u=true'}
                                target='_blank'
                                rel='noopener noreferrer'
                            >忘记密码？</Button>
                        </Col>

                    </Row>
                    <Row>
                        <Col span={11} offset={13}>
                            <Button
                                type='primary'
                                ref={loginRef}
                                style={{ background: CNF.themeColors[1], width: '100%', borderRadius: '0px', }}
                                onClick={login}
                            >
                                {loading ? <><LoadingOutlined />登录中</> : '登录'}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </ConfigProvider>
        </Flex>
    )
}

export default Login;